
const gotData = (state, payload) => {
  state[payload.model] = payload.data
}
const gotScore = (state, payload) => {
  state.ends[payload.ends][payload.angle].score = payload.score
  state.ends[payload.ends][payload.angle].right.height = payload.height || state.ends[payload.ends][payload.angle].right.height
}
const updateEnds = (state) => {
  for (const ends in state.ends) {
    for (const angles in state.ends[ends]) {
      state.ends[ends][angles].left.top = Math.floor(Math.random() * (120 - 60)) + 60
      state.ends[ends][angles].right.top = Math.floor(Math.random() * (120 - 60)) + 60
      if (angles.includes('S')) {
        state.ends[ends][angles].left.height = Math.round((Math.floor(Math.random() * (150 - 80)) + 80) / 5) * 5
        state.ends[ends][angles].right.height = Math.round((Math.floor(Math.random() * (260 - 160)) + 160) / 5) * 5
      } else { // Lengthen
        state.ends[ends][angles].left.height = Math.round((Math.floor(Math.random() * (260 - 160)) + 160) / 5) * 5
        state.ends[ends][angles].right.height = Math.round((Math.floor(Math.random() * (150 - 80)) + 80) / 5) * 5
      }
    }
  }
}
export default {
  gotData,
  gotScore,
  updateEnds
}
